import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { withAppLayout, withAuthOnly } from '../core/routes';
import OrdersPage from './pages/OrdersPage';
import OrderFormPage from './pages/OrderFormPage';
import OrderPaymentReceiptPage from './pages/OrderPaymentReceiptPage';
import OrderQuotePrintPage from './pages/OrderQuotePrintPage';
import OrderPublicFormPage from './pages/OrderPublicFormPage';
import OrderQuickIntakePage from './pages/OrderQuickIntakePage';
import OrderWorkflowSettingsPage from './pages/OrderWorkflowSettingsPage';
import WorkflowEditorPage from './pages/WorkflowEditorPage';

const LegacyFormularioRedirect = () => {
  const { workspaceId, token } = useParams();
  return <Navigate to={`/form/${workspaceId}/${token}`} replace />;
};

const OrderIdToEditRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/orders/${encodeURIComponent(id)}/edit`} replace />;
};

export const ordersRoutes = [
  { path: '/form/:workspaceId/:token', element: <OrderPublicFormPage /> },
  { path: '/solicitacao/:workspaceId', element: <OrderQuickIntakePage /> },
  { path: '/formulario/:workspaceId/:token', element: <LegacyFormularioRedirect /> },
  {
    path: '/orders/workflow/types/:typeId/edit',
    element: withAuthOnly(<WorkflowEditorPage />),
  },
  {
    path: '/orders/workflow',
    element: withAppLayout(<Navigate to="/orders/workflow/catalog" replace />),
  },
  {
    path: '/orders/workflow/:section',
    element: withAppLayout(<OrderWorkflowSettingsPage />),
  },
  { path: '/orders', element: withAppLayout(<OrdersPage />) },
  { path: '/orders/new', element: withAppLayout(<OrderFormPage />) },
  {
    path: '/orders/:orderId/payments/:paymentId/receipt',
    element: withAuthOnly(<OrderPaymentReceiptPage />),
  },
  { path: '/orders/:id/quote', element: withAuthOnly(<OrderQuotePrintPage />) },
  { path: '/orders/:id', element: withAppLayout(<OrderIdToEditRedirect />) },
  { path: '/orders/:id/edit', element: withAppLayout(<OrderFormPage />) },
];
